export const DEFAULT_NUM_IDS_PER_REQUEST = 500;

export const SKIP_CACHE_QUERY_PARAM = "skipCache";
